import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Button from '@material-ui/core/Button';
import { connect } from "react-redux";
import { compose } from "redux";
// import Typography from '@material-ui/core/Typography';
import { UpdateLibraryStatus } from "../actions/LibraryAction"
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Grid from '@material-ui/core/Grid';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Badge from '@material-ui/core/Badge';

function getSteps() {
	return ['Approved Libraries', 'Pending Libraries'];
}

const { innerWidth } = window;

const CustomTableCell = withStyles(theme => ({
	head: {
		//backgroundColor: theme.palette.common.black,
		color: "#2926ac",
		fontWeight: "bold",
		fontSize: 13
	},
	body: {
		fontSize: 14,
	},
}))(TableCell);

const styles = theme => ({
	root: {
		width: '100%',
		// marginTop: theme.spacing.unit * 3,
		// overflowX: 'auto',
	},
	button: {
		margin: theme.spacing.unit,
		textTransform: "none"
	},
	table: {
		// minWidth: 700,
	},
	row: {
		'&:nth-of-type(odd)': {
			backgroundColor: theme.palette.background.default,
		},
	},
});


class NewLibraryRequest extends Component {
	constructor() {
		super()
		this.state = {
			value: 0,
			confirmAlert: false,
			selectedStatus: null,
			selectedLibraryId: null,
			message: null,
			activeStep: 0,
		}
	}

	componentDidMount() {
	}

	handleNext = (step) => {
		this.setState(state => ({
			activeStep: step,
		}));
	};
	handlenex = (st) => {
		this.setState(state => ({ activeStep: st }))
	}
	handleChange = (event, value) => {
		this.setState({ value });
	};

	handleCloseDialog = (state) => {
		this.setState({ confirmAlert: false })
		if (state === "Yes") {
			this.props.dispatch(UpdateLibraryStatus(this.state.selectedStatus, this.state.selectedLibraryId))
		}
	}

	changeLibraryStatus = (status, id) => {
		let statusMessage = status === 'ACTIVE' ? "activate" : "reject";
		let message = "Do you want to " + statusMessage + " this library ?"
		this.setState({ confirmAlert: true, selectedStatus: status, selectedLibraryId: id, message })
	}


	render() {
		const { classes } = this.props;
		const steps = getSteps();
		const { activeStep } = this.state;
		return (
			<div className={classes.root}>
				<Grid container spacing={8}>
					<Grid item xs={innerWidth > 480 ? 2 : 12}>
						<Stepper activeStep={activeStep} orientation={innerWidth > 480 ? "vertical" : "horizontal"}>
							{
								steps.map((label, index) => (
									<Step key={label}>
										{
											index === 0
												? <StepLabel
													icon={<FontAwesomeIcon icon="check-circle" style={{ fontSize: 20 }} />}
												>

													<Button
														disabled={activeStep === 0}
														variant="contained"
														onClick={() => this.handleNext(index)}
														className={classes.button}
														style={{ background: 'linear-gradient(to right, #2926ac 0%, #6128be 100%)', color: "#FFFFFF", opacity: activeStep === 1 ? 0.6 : null }}
													>
														{label}
													</Button>

												</StepLabel>
												: <StepLabel
													icon={<FontAwesomeIcon icon="clock" style={{ fontSize: 20 }} />}
												>

													{/* <Button
														disabled={activeStep === 1}
														variant="contained"
														onClick={() => this.handleNext(index)}
														className={classes.button}
														style={{ background: 'linear-gradient(to right, #2926ac 0%, #6128be 100%)', color: "#FFFFFF", opacity: activeStep === 0 ? 0.6 : null }}
													>
														<Badge className={classes.margin} badgeContent={this.props.pendingLibraries.length} color="secondary" style={{ top: -4, right: -9 }}> {label} </Badge>
													</Button> */}

													<Badge color="secondary" badgeContent={this.props.pendingLibraries.length} className={`${classes.button}`}>
														<Button
															disabled={activeStep === 1}
															variant="contained"
															onClick={() => this.handleNext(index)}
															//className={classes.button}
															style={{ background: 'linear-gradient(to right, #2926ac 0%, #6128be 100%)', color: "#FFFFFF", textTransform: 'none', opacity: activeStep === 0 ? 0.6 : null }}
														>
															{label}
														</Button>
													</Badge>

												</StepLabel>
										}
									</Step>
								))
							}
						</Stepper>
					</Grid>
				
					<Grid item xs={innerWidth > 480 ? 10 : 12} style={{ overflowX: 'auto' }}>
						{
							activeStep === 0
								?
								<Table className={classes.table}>
									<TableHead>
										<TableRow>
											<CustomTableCell>Library Name</CustomTableCell>
											<CustomTableCell align="left">Library mailing address</CustomTableCell>
											<CustomTableCell align="left">Library Phone</CustomTableCell>
											<CustomTableCell align="left">Status</CustomTableCell>
										</TableRow>
									</TableHead>
									<TableBody>
										{this.props.approvedLibraries.length > 0 ?
											this.props.approvedLibraries.map(row => (
												<TableRow className={classes.row} key={row.id}>
													<CustomTableCell component="th" scope="row">
														{row.library_name}
													</CustomTableCell>
													<CustomTableCell align="left">{row.library_email}</CustomTableCell>
													<CustomTableCell align="left">{row.library_phone}</CustomTableCell>
													<CustomTableCell align="left" style={{textTransform: 'capitalize'}}>{row.status !== null ? row.status.toLowerCase() : '-'}</CustomTableCell>
												</TableRow>
											))
											:
											<TableRow className={classes.row} key={0} style={{ textAlign: "center" }}>
												<CustomTableCell colSpan={4} style={{ textAlign: 'center' }}>There is no libraries to view</CustomTableCell>
											</TableRow>
										}
									</TableBody>
								</Table>
								:
								<Table className={classes.table}>
									<TableHead>
										<TableRow>
											<CustomTableCell>Library Name</CustomTableCell>
											<CustomTableCell align="left">Library mailing address</CustomTableCell>
											<CustomTableCell align="left">Library Phone</CustomTableCell>
											<CustomTableCell align="left">Status</CustomTableCell>
											<CustomTableCell align="left">Actions</CustomTableCell>
										</TableRow>
									</TableHead>
									<TableBody>
										{ this.props.pendingLibraries.length > 0 ?
											this.props.pendingLibraries.map(row => (
												<TableRow className={classes.row} key={row.id}>
													<CustomTableCell component="th" scope="row">
														{row.library_name}
													</CustomTableCell>
													<CustomTableCell align="left">{row.library_email}</CustomTableCell>
													<CustomTableCell align="left">{row.library_phone}</CustomTableCell>
													<CustomTableCell align="left" style={{textTransform: 'capitalize'}}>{row.status !== null ? row.status.toLowerCase() : '-'}</CustomTableCell>
													<CustomTableCell align="left">
														<Button variant="contained" size="small" color="primary" className={classes.button} onClick={() => this.changeLibraryStatus("ACTIVE", row.id)}>
															Accept
														</Button>
														{/* <Button variant="contained" size="small" color="secondary" className={classes.button} onClick={() => this.changeLibraryStatus("REJECTED", row.id)}>
															Reject
														</Button> */}
														
													</CustomTableCell>
												</TableRow>
											))
											:
											<TableRow className={classes.row} key={0} style={{ textAlign: "center" }}>
												<CustomTableCell colSpan={5} style={{ textAlign: 'center' }}>There is no libraries to view</CustomTableCell>
											</TableRow>
										}
									</TableBody>
								</Table>
						}
					</Grid>
				</Grid>

				<Dialog
					open={this.state.confirmAlert}
					aria-labelledby="alert-dialog-title"
					aria-describedby="alert-dialog-description"
				>
					<DialogTitle id="alert-dialog-title">{this.state.message}</DialogTitle>
					<DialogActions>
						<Button onClick={() => this.handleCloseDialog('No')} color="secondary">
							No
						</Button>
						<Button onClick={() => this.handleCloseDialog('Yes')} color="primary" autoFocus>
							Yes
                		</Button>
					</DialogActions>
				</Dialog>
			</div>
		);
	}
}


NewLibraryRequest.propTypes = {
	classes: PropTypes.object.isRequired,
};


const mapStateToProps = (state) => {
	return {
		defaultRole: state.SessionReducer.defaultRole,
		myLibrary: state.LibraryReducer.myLibrary,
		approvedLibraries: state.LibraryReducer.approvedLibraries,
		pendingLibraries: state.LibraryReducer.pendingLibraries,
	}
}

export default compose(withStyles(styles), connect(mapStateToProps))(NewLibraryRequest);